<template>
  <el-checkbox
    :true-label="trueLabel"
    :false-label="falseLabel"
    :value="value"
    @input="change"
  >{{ text ? $t(text) : '' }}</el-checkbox>
</template>

<script>
export default {
  inject: {
    $page: {
      default: () => ({})
    }
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    value: {
      type: null,
      default: 'N'
    },
    trueLabel: {
      type: null,
      default: 'Y'
    },
    falseLabel: {
      type: null,
      default: 'N'
    }
  },
  methods: {
    change(val) {
      this.$emit('input', val)
    }
  }
}
</script>
